export default __webpack_public_path__ + "static/media/multiasset-balancing-mob-banner.8a0b3660.jpg";